import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'

export const DeleteNoteEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.deleteNoteRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return ProjectRepository.deleteNote(action.payload.projectId, action.payload.noteId).pipe(
        mergeMap(() =>
          of(
            project.deleteNoteRequestSuccess({
              projectId: action.payload.projectId,
              noteId: action.payload.noteId
            })
          )
        ),
        catchError((error) => of(project.deleteNoteRequestFailure({ error })))
      )
    })
  )
